import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
const rubk = (props) => (
  <SvgIcon width="18.66" height="14.7" viewBox="0 0 18.66 14.7" {...props}>
    <path d="M10.542,7.226A5.4,5.4,0,0,0,5.494,3.811,5.372,5.372,0,0,0,2.821,4.5V0L0,2.772V9.206H0a5.429,5.429,0,0,0,5.444,5.444,5.687,5.687,0,0,0,3.663-1.386h0l.1-.1.247-.247.792-.792L11.73,14.7h3.217l-2.673-4.6-.2.2L18.66,3.762H14.7l-3.96,3.96h0L7.424,11.037v.049h0l-.049.049a2.66,2.66,0,1,1,0-3.762,2.236,2.236,0,0,1,.544.841l.594.99" />
  </SvgIcon>
);
export default rubk;



// WEBPACK FOOTER //
// ./src/common/icons/Rubk/index.tsx